<template>
    <div>
        <div class="lke-bg">
            <div class="lke-top">
                <div class="lke-top-l">您现在所在的位置：联系我们</div>
                <div class="lke-top-r" @click="openRouter('indexPage')">返回首页
                    <i class="el-icon-arrow-down"></i>
                </div>
            </div>
           <div class="lke-fot">
               <div class="lke-fot-top">
                   <div class="lke-fot-top-l"></div>
                   <div class="lke-fot-top-r">
                       <span>
                           联系我们
                       </span>
                   </div>
               </div>
               <div class="lke-text">
                   <div class="lke-text-l">
                       <p><span><span class="lke-1">地</span>址：北京市朝阳区白家庄路6号</span></p>
                       <p><span><span class="lke-1">邮</span>编：100020</span></p>
                       <p><span><span>咨询电话</span>：010-65012369</span></p>
                       <p><span><span>教学技术</span>：010-65006033</span></p>
                   </div>
                   <div class="lke-text-r"></div>
               </div>
           </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

        openRouter(val){
             this.$router.push({ name: val });
        }

    },
    components: {

    },
};
</script>

<style>

</style>

<style scoped>
.lke-top{
    width: 1024px;
    margin: 0 auto !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
}
.lke-top-l{
    font-size: 16px;
    padding-left: 20px;
}
.lke-top-r{
    font-size: 16px;
    padding-right: 20px;
    cursor: pointer;
}
.lke-top-r:hover{
    color: #2890F4;
}
.lke-fot{
    margin: 0 auto;
    width: 1024px;
}
.lke-fot-top{
    margin: 0 20px;
    padding-bottom: 8px;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    border-bottom: 2px solid #2890F4;
}
.lke-fot-top-l{
    width: 10px;
    background: #86C2FD;
    height: 28px;
    margin-right: 10px;
}
.lke-fot-top-r{
    font-size: 26px;
    color: #2890F4;
}
.lke-text{
    padding: 20px;
    padding-bottom: 60px;
    display: flex;
}
.lke-text-l{
    padding: 20px;
    padding-left: 40px;
    padding-right: 60px;
    font-size: 17px;
    line-height: 2.5;
}
.lke-1{
    letter-spacing: 34px;
}
.lke-text-r{
    flex: 1;
    border: 1px solid #ccc;
    margin-right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/lxwm/lxwm.vue